import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1>Üdvözlünk a <span className="pek-gidi-text">Pék Gidi</span> oldalán!</h1>
          <p>Kézműves pékség a legjobb alapanyagokból, szeretettel készítve.</p>
          <Link to="/products" className="btn btn-primary">Termékek böngészése</Link>
        </div>
      </section>
      
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <p>
                A <span className="pek-gidi-text">Pék Gidi</span> egy családi vállalkozás, amely több mint 20 éve készít hagyományos magyar péktermékeket.
                Minden termékünk gondosan válogatott alapanyagokból készül, adalékanyagok és tartósítószerek nélkül.
              </p>
              <p>
                Célunk, hogy visszahozzuk a régi idők ízeit, amikor a kenyér még valódi kenyér volt, és a péksütemények
                frissen, szeretettel készültek. Termékeink között megtalálhatók a hagyományos magyar kenyerek, kalácsok,
                pogácsák és egyéb finomságok.
              </p>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <span>Kézműves pékség képe</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="features-section">
        <div className="container">
          <h2>Miért válassz minket?</h2>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">🌾</div>
              <h3>Minőségi alapanyagok</h3>
              <p>Csak a legjobb, gondosan válogatott alapanyagokat használjuk termékeinkhez.</p>
            </div>
            
            <div className="feature">
              <div className="feature-icon">👨‍🍳</div>
              <h3>Kézműves készítés</h3>
              <p>Minden termékünk kézzel készül, a hagyományos receptek szerint.</p>
            </div>
            
            <div className="feature">
              <div className="feature-icon">🚚</div>
              <h3>Kényelmes átvétel</h3>
              <p>Válaszd ki a legközelebbi átvételi pontot, és vedd át frissen a rendelésedet.</p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <div className="container">
          <h2>Rendelj most!</h2>
          <p>Böngészd termékeinket és add le rendelésedet online, egyszerűen.</p>
          <Link to="/products" className="btn btn-primary">Termékek megtekintése</Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
